import { render, staticRenderFns } from "./header.vue?vue&type=template&id=08e432c6&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=08e432c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../blsguanfang_blszf/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports